import { Component } from '@angular/core';
// import { AuthService } from "./services/auth.service";
// import { Router, ActivatedRoute } from '@angular/router';
// import { GlobalEventsManager } from './services/global.service';


@Component({
  selector: 'app-root',
   template: '<router-outlet></router-outlet>',
  // templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  // title = 'app';
  // isLogin = false;
  // public disabled:boolean = false;
  // public status:{isopen:boolean} = {isopen: false};


  constructor(
    // private authService: AuthService,
    // private route: ActivatedRoute,
    // private router: Router,
    // private globalEventsManager: GlobalEventsManager
  ) { }

  ngOnInit() {
    // this.isLogin = this.authService.checkLogin();
    
    // this.globalEventsManager.showNavBarEmitter.subscribe((mode) => {
    //   // mode will be null the first time it is created, so you need to ignore it when null
    //   if (mode !== null) {
    //     this.isLogin = mode;
    //   }
    // });
  }

  //  public toggled(open:boolean):void {
  //   console.log('Dropdown is now: ', open);
  // }

  //   public toggleDropdown($event:MouseEvent):void {
  //   $event.preventDefault();
  //   $event.stopPropagation();
  //   this.status.isopen = !this.status.isopen;
  // }


  // logOut() {
  //   console.log("logout")
  //   this.authService.logout();
  //   this.router.navigate(["/login"]);
  // }
}



// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/app.component.ts